import React, { useEffect, useState } from 'react';
import { Button, TextField } from '@mui/material';
import { axiosPostCall } from 'src/services/apisCall';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import { ConfirmDialog } from 'src/components/custom-dialog';

const EditLogger = ({ open, onClose, data, forceLoad, loadit }) => {
  const [newName, setNewName] = useState('');

  useEffect(() => {
    if (open) {
      setNewName(data?.scriptName || '');
    }
  }, [open, data]);

  const handleSave = async () => {
    const { scriptName, level, env } = data;

    const updatedData = {
      env,
      scriptName: newName,
      oldScriptName: scriptName,
      logLevel: level,
    };

    try {
      const response = await axiosPostCall('changeLogLevel', updatedData);
      if (response) {
        renderSuccessMessage('Script updated successfully');
      }
      forceLoad(!loadit);
      onClose();
    } catch (error) {
      renderErrorMessage(error?.message);
    }
  };
  const content = () => {
    return (
      <>
        <TextField
          sx={{ mt: 1 }}
          label="Script Name"
          variant="outlined"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          fullWidth
        />
      </>
    );
  };
  return (
    <ConfirmDialog
      title="Edit Script"
      content={content()}
      action={
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      }
      open={open}
      onClose={onClose}
    />
  );
};

export default EditLogger;
